import React from 'react';
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // In production you'd send this to a monitoring service (Sentry, etc.)
    console.error('[ErrorBoundary] Uncaught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-reglow-bg flex items-center justify-center p-8">
          <div className="max-w-md w-full text-center space-y-8">
            <div className="h-24 w-24 bg-red-50 rounded-full flex items-center justify-center mx-auto border border-red-100 shadow-sm">
              <ExclamationTriangleIcon className="h-12 w-12 text-red-500" />
            </div>
            <div>
              <h1 className="text-4xl font-bold text-gray-900 tracking-tighter mb-3">
                Oups !{' '}
                <span className="text-red-500">
                  Erreur
                </span>
              </h1>
              <p className="text-gray-500 font-medium">
                Une erreur inattendue s'est produite. Nos équipes ont été notifiées.
              </p>
              {process.env.NODE_ENV !== 'production' && this.state.error && (
                <pre className="mt-4 text-left text-xs text-red-700 bg-red-50 border border-red-200 rounded-2xl p-4 overflow-auto max-h-40">
                  {this.state.error.toString()}
                </pre>
              )}
            </div>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = '/';
              }}
              className="flex items-center space-x-2 mx-auto px-8 py-4 bg-reglow-primary hover:bg-primary-600 text-white rounded-2xl font-bold transition-all shadow-md"
            >
              <ArrowPathIcon className="h-5 w-5" />
              <span>Retour à l'Accueil</span>
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
